<template>
    <!-- ,'webkit-transform':`scale(${scale}) translate(-50%, -50%)`} -->
    <div :class="{'scale-box':isScale && scale != 1}" :style="{'transform':`scale(${scale}) translate(${scale!==1?'-50%, -50%':'0,0'})`,'webkit-transform':`scale(${scale}) translate(${scale!==1?'-50%, -50%':'0,0'})`}">
        <slot></slot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { debounce } from '@/util/util'
export default {
    name: 'scale-box',
    props: {
        width: {
            type: Number,
            default: 1679
        },
        height: {
            type: Number,
            default: 1154
        },
        isScale: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            scale: '',
            menuW: 0
        }
    },
    watch: {
        isScale: {
            deep: true,
            handler(val) {
                if (this.isScale) {
                    this.scale = this.getScale()

                } else {
                    this.scale = 1
                }
                window.addEventListener('resize', this.setScale)

            }
        }
    },
    mounted() {
        if (this.isScale) {
            this.scale = this.getScale()
        } else {
            this.scale = 1
        }
        window.addEventListener('resize', this.setScale)
    },
    computed: mapGetters(["isCollapse"]),
    methods: {
        getScale() {
            let menuWidth = 0
            if (window.innerWidth > 992) {
                if (this.isCollapse) {
                    menuWidth = 60
                } else {
                    menuWidth = 240
                }
            }
            this.menuW = menuWidth / window.outerWidth / 2
            // const { width = 1920, height = 1080 } = this.props
            let ww = (window.outerWidth - menuWidth * 2) / this.width
            let wh = window.outerHeight / this.height
            console.log(`屏幕的宽度是${window.outerWidth - menuWidth} 屏幕的高度是${window.outerHeight}`)
            console.log(`宽度比例${ww} 高度比例${wh}`)
            if (ww < 1 || wh < 1) {
                return 1
            } else {
                return ww < wh ? ww : wh
            }

        },
        setScale() {
            // debounce(() => {
            if (this.isScale) {
                this.scale = this.getScale()

            } else {
                this.scale = 1
            }
            // }, 500)
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setScale)
    }
}

</script>
<style lang="scss" scoped>
.scale-box {
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 50%;
    max-width: 1920px;
    transition: 0.3s;
}

</style>
